// extracted by mini-css-extract-plugin
export default {"container":"Content1_container__XzwIH","button":"Content1_button__AOydg","textArea":"Content1_textArea__QRpZ8","text":"Content1_text__2sAc5"};